
import DesignList from "components/designs-list";

const DeletedDesigns = () => {
  return (
    <DesignList limit={15} heading={"Deleted Designs"} showPagination={true} isDeletePage={true}/>
  );
};

export default DeletedDesigns;
